/**
 * Shop by Sound — switches section
 * Audio playback lives in shop-by-sound-base.js ([data-sbs-hear]).
 */
(function () {
  'use strict';
})();
